import { forwardRef } from 'react';
import { Input, InputProps, InputRef } from 'antd';
import { formatNominal, NOMINAL_INPUT_PATTERN } from '../../utils/nominal';

type NominalInputProps = Omit<InputProps, 'value' | 'onChange'> & {
	nominal: string | number | null | undefined;
	decimals: number | null | undefined;
	/** The text as typed, so its places survive; null when cleared. */
	onChange: (nominal: string | null) => void;
};

/**
 * A text input rather than an InputNumber: InputNumber hands back a number, which drops
 * the trailing zeros that say how tight the nominal is (1.000 vs 1).
 */
const NominalInput = forwardRef<InputRef, NominalInputProps>(
	({ nominal, decimals, onChange, ...props }, ref) => (
		<Input
			ref={ref}
			inputMode="decimal"
			autoComplete="off"
			{...props}
			value={formatNominal(nominal, decimals)}
			onChange={(e) => {
				const text = e.target.value.trim();
				if (!NOMINAL_INPUT_PATTERN.test(text)) return;
				onChange(text === '' ? null : text);
			}}
		/>
	)
);

NominalInput.displayName = 'NominalInput';

export default NominalInput;
